import React, { useState, useEffect } from "react";
import axios from "axios";
import Layout from '../../../Components/Layout';
import Breadcrumb from '../Component/Breadcrumb';
import Sidebar from '../../Dashboard/Component/Siderbar';
import Swal from 'sweetalert2'
import { useLocation, useNavigate } from 'react-router-dom';
import config from "../../../config";

export default function Add() {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [coins, setCoins] = useState([]);
    const userData = JSON.parse(localStorage.getItem('user_data'));
    const [selectedCard, setSelectedCard] = useState(null);
    const [formData, setFormData] = useState({
        amount: '',
        cardHolderName: '',
        cardNumber: '',
        expireDate: '',
        cvv: ''
      });
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
          ...formData,
          [name]: value
        });
      };

       console.log(userData);

    /* const handleCardClick = (coin) => {
        setSelectedCard(coin);
      }; */

    useEffect(() => {
        const fetchCoins = async () => {
          try {
            const response = await axios.get(`${config.API_BASE_URL_V1}wallet/coins`, {
              headers: {
                Authorization: `Bearer ${userData.token}`, // Buraya doğru Bearer token ekleyin
              },
            });
            
            if (response.data && response.data.status === "success") {
              setCoins(response.data.data);
            } else {
              console.error("Veri fetch edilemedi:", response.data.message);
            }
          } catch (error) {
            console.error("Hata oluştu:", error);
          }
        };
    
        fetchCoins();
      }, []);

    const handleExpireDateChange = (e) => {
      let value = e.target.value;
    
      // Rakam dışındaki karakterleri kaldır
      value = value.replace(/[^0-9]/g, "");
    
      // 2 rakamdan sonra '/' ekle
      if (value.length > 2) {
        value = value.slice(0, 2) + "/" + value.slice(2);
      }
    
      // Maksimum 5 karakter kontrolü (MM/YY formatı için)
      if (value.length > 5) {
        value = value.slice(0, 5);
      }
    
      setFormData({ ...formData, expireDate: value });
    };

    const handleSubmit = async (e) => {
      e.preventDefault(); // Sayfanın yeniden yüklenmesini engelle
    
      try {
        // expireDate'i (MM/YY) parçala
        const [expireMonth, expireYear] = formData.expireDate.split("/");
    
        // API isteği için gerekli veriler
        const requestData = {
          agency_id: 1, // Örnek sabit değer, gerekirse dinamik yap
          price: parseFloat(formData.amount), // Fiyatı al
          card_number: formData.cardNumber,
          cvc: parseFloat(formData.cvv),
          expire_month: expireMonth,
          expire_year: expireYear,
          currency: 'EUR',
        };
    
        console.log('requestData: ', requestData);
        // Bearer Token ile istek
        const response = await axios.post(
          `${config.API_BASE_URL_V1}wallet/add-balance`,
          requestData,
          {
            headers: {
              Authorization: `Bearer ${userData.token}`, // Bearer token'ı değiştir
            },
          }
        );
        if (response.status === 200) {
          Swal.fire({
              title: response.message,
              icon: "error",
              draggable: true,
          });
          navigate('/dashboard-credit');
          window.scrollTo(0, 0);
        } else {
          Swal.fire({
            title: "Successfully!",
            icon: "success",
            draggable: true,
        });
        }
      } catch (error) {
        Swal.fire({
          title: "Try again later",
          icon: "error",
          draggable: true,
      });
      }
    };
      
return (
<Layout>
    <Breadcrumb title="Add Credit" />
    <div className="content">
        <div className="container">
            <div className="row">
                <Sidebar />
                <div className="col-xl-9">
                        <form onSubmit={handleSubmit}>
                          <div className="card shadow-none" id="basic_info">
                            <div className="card-header">
                                <div className="d-flex align-items-center justify-content-between">
                                    <h5 className="fs-18">Buy Credit</h5>
                                </div>
                            </div>
                            <div className="card-body pb-1">
                                <div class="d-flex flex-column">
                                <div className="col-xl-12 col-lg-12 d-flex flex-row mb-4">
                                    <p className="col-md-6 m-auto" style={{ textAlign:'right', marginLeft:'100px' }}>Credit amount  :</p>
                                    <div className="d-flex col-md-3">
                                        <input type="number" required className="form-control" name="amount" id="amount" value={formData.amount} onChange={handleChange}
                                        />
                                    </div>
                                    {/* <div className="row flex-fill">
                                        {coins?.map((item, index) => (
                                            <div
                                            key={index}
                                            id={`coin-card-${item.id}`} // Benzersiz id atanıyor
                                            className="col-xl-4 col-lg-4 col-md-4 d-flex"
                                            onClick={() => handleCardClick(item)}
                                            style={{ cursor: "pointer" }}
                                            >
                                            <div
                                                className={`card shadow-none mb-4 flex-fill ${
                                                selectedCard?.id === item.id ? "border-black" : ""
                                                }`}
                                            >
                                                <div className="card-body">
                                                <span className="avatar avatar-lg rounded-circle bg-secondary mb-3">
                                                    <i className="isax isax-money-send5 text-white"></i>
                                                </span>
                                                <div className="mb-3">
                                                    <p className="mb-0 text-truncate line-ellipsis-2">
                                                    {item.name}
                                                    </p>
                                                    <h4>{item.price} EUR</h4>
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        ))}
                                    </div> */}
                                </div>
                                <div className="col-xl-12 col-lg-12 d-flex">
                                <div className="card payment-details flex-fill mb-4">
                                    <div className="card-header">
                                    <h5>Credit / Debit Card</h5>
                                    </div>
                                    <div className="card-body">
                                    <div className="tab-pane fade active show" id="wallet">
                                        <div className="credit-card-details">
                                        <div className="card-form">
                                            <div className="row">
                                            <div className="col-lg-12">
                                                <div className="mb-2">
                                                <label className="form-label">Card Holder Name</label>
                                                <div className="user-icon">
                                                    <span className="input-icon fs-14">
                                                    <i className="isax isax-user"></i>
                                                    </span>
                                                    <input
                                                    type="text"
                                                    name="cardHolderName"
                                                    className="form-control"
                                                    placeholder="Enter card holder name"
                                                    value={formData.cardHolderName}
                                                    onChange={handleChange}
                                                    required
                                                    />
                                                </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-12">
                                                <div className="mb-2">
                                                <label className="form-label">Card Number</label>
                                                <div className="user-icon">
                                                    <span className="input-icon fs-14">
                                                    <i className="isax isax-card-tick"></i>
                                                    </span>
                                                    <input
                                                    type="number"
                                                    name="cardNumber"
                                                    className="form-control"
                                                    placeholder="Enter card number"
                                                    value={formData.cardNumber}
                                                    onChange={handleChange}
                                                    required

                                                    />
                                                </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                <label className="form-label">Expire Date</label>
                                                <div className="user-icon">
                                                    <span className="input-icon fs-14">
                                                    <i className="isax isax-calendar-2"></i>
                                                    </span>
                                                    <input
                                                        type="text"
                                                        required
                                                        name="expireDate"
                                                        className="form-control"
                                                        placeholder="MM/YY"
                                                        value={formData.expireDate}
                                                        onChange={(e) => handleExpireDateChange(e)}
                                                        maxLength="5" // Maksimum 5 karakter (MM/YY formatı için)
                                                        />

                                                </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6">
                                                <div className="mb-3">
                                                <label className="form-label">CVV</label>
                                                <div className="user-icon">
                                                    <span className="input-icon fs-14">
                                                    <i className="isax isax-check"></i>
                                                    </span>
                                                    <input
                                                    type="number"
                                                    name="cvv"
                                                    required
                                                    maxLength={4}
                                                    minLength={2}
                                                    className="form-control"
                                                    placeholder="Enter CVV"
                                                    value={formData.cvv}
                                                    onChange={handleChange}
                                                    />
                                                </div>
                                                </div>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                        <div className="d-flex align-items-center justify-content-end">
                                        <button className="btn btn-primary">Buy Credi</button>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                                </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</Layout>
)
}
